import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import 'swiper/css/navigation';

interface PhotoGalleryProps {
  photos: string[];
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ photos }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);

  const openModal = (photo: string) => {
    setSelectedPhoto(photo);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedPhoto(null);
    setIsModalOpen(false);
  };

  return (
    <div className="h-full bg-white">
      <Swiper
        effect={'coverflow'}
        grabCursor
        centeredSlides
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 50,
          stretch: 20,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 'auto' },
        }}
        loop
        pagination
        modules={[EffectCoverflow, Pagination]}
        className="py-10 h-5/6"
      >
        {photos.map((photo, index) => (
          <SwiperSlide key={index} className="sm: w-9/12 md:w-1/4">
            <div
              onClick={() => openModal(photo)}
              className="flex items-center justify-center overflow-hidden rounded-lg cursor-pointer"
            >
              <img
                src={photo}
                alt={`Gallery Image ${index + 1}`}
                className="object-cover rounded-lg shadow-lg border-2 border-[#B94665]"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
          onClick={closeModal}
        >
          <div
            className="relative w-auto max-w-3xl p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 w-12 h-12 flex items-center justify-center rounded-full bg-[#F7F4EF] text-[#B94665] text-2xl hover:bg-[#B94665] hover:text-white transition-all duration-300 focus:outline-none focus:ring focus:ring-[#B94665] focus:ring-opacity-50"
              onClick={closeModal}
            >
              &times;
            </button>
            <img
              src={selectedPhoto!}
              alt="Enlarged view"
              className="rounded-lg shadow-lg border-2 border-[#B94665]"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;
